import { DetailedPlayerType } from "@/pages/DetailedPlayer/DetailedPlayer";
import type { BackendPlayerType } from "@repo/shared/api";
import { evolutionPathParam } from "@repo/shared/evolutions";
import { EvoPathId } from "@repo/shared/types";

import axios from "../../api";

export const getPlayer = async ({
  resourceId,
  backendPlayerType,
  playerRoleId,
  evoPathId,
  evolutionPath,
  pathwayPath,
  labPlayStylesPlus,
  labPlayStyles,
}: {
  resourceId: number;
  backendPlayerType: BackendPlayerType;
  playerRoleId?: number;
  evoPathId?: EvoPathId;
  evolutionPath?: number[];
  pathwayPath?: number[][];
  labPlayStylesPlus?: number[];
  labPlayStyles?: number[];
}) => {
  const params = new URLSearchParams({
    ...(playerRoleId ? { "player-role-id": playerRoleId.toString() } : {}),
    ...(evoPathId ? { evoPathId: evoPathId.toString() } : {}),
    ...(evolutionPath?.length
      ? { "evolution-path": evolutionPathParam(evolutionPath, pathwayPath) }
      : {}),
    ...(backendPlayerType !== "base" ? { type: backendPlayerType } : {}),
    ...(labPlayStylesPlus
      ? { labPlayStylesPlus: labPlayStylesPlus.join(",") }
      : {}),
    ...(labPlayStyles ? { labPlayStyles: labPlayStyles.join(",") } : {}),
  });

  // Build the URL properly, only adding ? if there are params
  let url = `/players/${resourceId}`;
  const queryString = params.toString();

  if (queryString) {
    url += `?v2&${queryString}`;
  }

  const res = await axios.get<DetailedPlayerType>(url);
  return res.data;
};
